const toFiniteNumber = (value) => {
  const n = Number(value);
  return Number.isFinite(n) ? n : null;
};

const normalizeCity = (value) => {
  const s = String(value ?? '').trim();
  return s || null;
};

const buildSearchUrl = (city) => {
  const q = encodeURIComponent(String(city || '').trim());
  return `https://nominatim.openstreetmap.org/search?format=json&limit=1&addressdetails=1&q=${q}`;
};

const buildReverseUrl = (lat, lng) => {
  const latS = encodeURIComponent(String(lat));
  const lngS = encodeURIComponent(String(lng));
  return `https://nominatim.openstreetmap.org/reverse?format=json&addressdetails=1&lat=${latS}&lon=${lngS}`;
};

const fetchJson = async (url, signal) => {
  const res = await fetch(url, {
    method: 'GET',
    headers: {
      Accept: 'application/json',
    },
    signal,
  });

  if (!res.ok) return null;
  try {
    return await res.json();
  } catch {
    return null;
  }
};

const pickCityLabel = (address = {}, fallback = null) => {
  const city =
    address.city ||
    address.town ||
    address.village ||
    address.municipality ||
    address.county ||
    address.state ||
    fallback;
  return normalizeCity(city);
};

export const geocodeCity = async (city, signal) => {
  const normalizedCity = normalizeCity(city);
  if (!normalizedCity) return null;

  const data = await fetchJson(buildSearchUrl(normalizedCity), signal);
  if (!Array.isArray(data) || data.length === 0) return null;

  const first = data[0] || {};
  const lat = toFiniteNumber(first.lat);
  const lng = toFiniteNumber(first.lon);
  if (!Number.isFinite(lat) || !Number.isFinite(lng)) return null;

  return {
    city: pickCityLabel(first.address, normalizedCity),
    lat,
    lng,
    displayName: normalizeCity(first.display_name),
  };
};

export const reverseGeocode = async (lat, lng, signal) => {
  const latN = toFiniteNumber(lat);
  const lngN = toFiniteNumber(lng);
  if (!Number.isFinite(latN) || !Number.isFinite(lngN)) return null;

  const data = await fetchJson(buildReverseUrl(latN, lngN), signal);
  if (!data || typeof data !== 'object') return null;

  return {
    city: pickCityLabel(data.address, data.display_name),
    displayName: normalizeCity(data.display_name),
  };
};
